import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "block w-full mb-4 pb-7" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = { class: "error-msg" }
const _hoisted_6 = { class: "inputTitle" }
const _hoisted_7 = { class: "inputField flex-grow" }
const _hoisted_8 = { class: "error-msg" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = { class: "flex-grow" }
const _hoisted_11 = ["value", "max"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "inputField flex-grow" }
const _hoisted_16 = ["max"]
const _hoisted_17 = {
  key: 0,
  class: "col-span-2 w-full"
}
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "inputField flex-grow flex items-center" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "icon-clipboard" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "col-span-2 w-full" }
const _hoisted_25 = { class: "inputTitle" }
const _hoisted_26 = { class: "inputField flex-grow" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = {
  key: 1,
  class: "col-span-2 w-full"
}
const _hoisted_29 = { class: "inputTitle" }
const _hoisted_30 = { class: "inputField flex-grow" }
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = {
  key: 2,
  class: "popupSectionHeader w-full"
}
const _hoisted_34 = { class: "mt-8 block w-full col-span-2" }
const _hoisted_35 = { class: "helpText mt-2 mb-2" }
const _hoisted_36 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_37 = { class: "flex justify-end" }
const _hoisted_38 = { class: "helpText mt-2 mb-2" }
const _hoisted_39 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_40 = { class: "flex justify-end" }
const _hoisted_41 = { class: "w-full helpText" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "grid grid-cols-2 gap-4 w-full mt-4" }
const _hoisted_44 = { class: "inputTitle" }
const _hoisted_45 = { class: "inputField flex-grow" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "error-msg" }
const _hoisted_48 = { class: "inputTitle" }
const _hoisted_49 = { class: "inputField flex-grow" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = { class: "error-msg" }
const _hoisted_52 = { class: "inputTitle" }
const _hoisted_53 = { class: "inputField flex-grow" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { class: "error-msg" }

import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import {computed, onMounted, reactive, Ref, ref, toRef} from "vue";
import useVuelidate from "@vuelidate/core";
import {email, helpers, required, requiredIf} from "@vuelidate/validators";
import Select from "@/components/inputs/Select.vue"
import {ErrorLocationType, FileStatus, TicketType} from "@/utilities/enums/Enums";
import Option from "@/models/helpers/Option";
import FileService from "@/utilities/services/entities/FileService";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ConfigService from "@/utilities/services/entities/ConfigService";
import TabLayeredItem from "@/components/tabs/TabLayeredItem.vue";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import TabsWrapper from "@/components/tabs/TabsWrapper.vue";
import {Grid, Store, StringHelper} from "@bryntum/grid";
import {baseURL, checkboxColumnConfig} from "@/AppConfig";
import RecipientService from "@/utilities/services/entities/RecipientService";
import RecipientlistService from "@/utilities/services/entities/RecipientlistService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {notify} from "@kyvg/vue3-notification";
import {$t} from "@/utilities/i18n/config";
import {validateDateString} from "@/utilities/helpers/CustomValidators";
import RecipientList from "@/models/entities/RecipientList";
import Recipient from "@/models/entities/Recipient";
import {TicketFileInfo} from "@/models/entities/ModelHelpers";
import ProjectFile from "@/models/entities/ProjectFile";
import Ticket from "@/models/entities/Ticket";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketEditPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();
const props = __props
const popupData = toRef(props, 'data') as Ref<Ticket>;

const isEdit = computed<boolean>(()=> popupData.value?.id >= 0);
const isLoading = ref<boolean>(false);
const activeTab = ref<number>(0);
const fileService = new FileService();
const configService = new ConfigService();
const recipientService = new RecipientService();
const recipientlistService = new RecipientlistService();

const isUpload = computed<boolean>(()=>{
  return popupData.value!.type === TicketType.upload;
})
const fileList = ref<ProjectFile[]>([]);

const configuredMaximumAttempts = ref<number>(0);
const configuredMaximumAttemptsExpiresAtDate = ref<string>("");
const expiresAtDate = computed(() => {
  return popupData.value?.validity.expiresAt.split('T')[0] ?? "";
})
const reactToDateValueChanges = (e: any) => {
  if (!e.target.value) return
  if (e.target.value.split("T")[0] > configuredMaximumAttemptsExpiresAtDate.value) return
  popupData.value!.validity.expiresAt = getGermanIsoString(new Date(e.target.value));
}

const hasNewRecipientData = () => {
  return !isEdit.value && (!NullOrUndefinedHelper(popupData.value?.newRecipient.firstName)
      || !NullOrUndefinedHelper(popupData.value?.newRecipient.lastName)
      || !NullOrUndefinedHelper(popupData.value?.newRecipient.email))
}

const rules = computed(() => {
  return {
    type: {
      required: helpers.withMessage(t('general.validation.required'), required)
    },
    file: {
      fileID: {
        requiredIf: helpers.withMessage(
            t('general.validation.required'),
            requiredIf(()=> {
              return [TicketType.download, TicketType.staticDownload]
                  .includes(popupData.value!.type)
            })
        )
      }
    },
    newRecipient: {
      firstName: { required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)) },
      lastName: { required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)) },
      email: {
        required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)),
        email: helpers.withMessage(t('general.validation.email'), email)
      },
    },
    validity: {
      expiresAt: {
        date: helpers.withMessage(t('general.validation.date'), validateDateString),
        maximum: helpers.withMessage(t('general.validation.valueExceedsMaximum'), ()=>{
          return new Date(popupData.value!.validity.expiresAt) <= new Date(configuredMaximumAttemptsExpiresAtDate.value)
        })
      }
    }
  }
})
const v$ = ref(useVuelidate(rules, popupData.value));

const gridStore = new Store()
const grid = ref<{instance:{value:Grid}}|null>(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "360px",
  columns: [
    {
      id:'name',
      field: 'name',
      text: t('recipient.tabs.recipient.grid.name'),
      flex: 1,
      type: "template",
      template: ({record}:any) => {
        return StringHelper.xss`${record.firstName} ${record.lastName}`;
      }
    },
    {
      id: 'email',
      field : 'email',
      text: t('recipient.tabs.recipient.grid.email'),
      flex: 1,
      sortable: true
    },
  ],
  store: gridStore,
  listeners:{
    selectionChange(event:any) {
      popupData.value!.recipients = event.selection.map((sr:any) => sr.originalData as Recipient);
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const gridConfig = reactive(useGridConfig)

const listGridStore = new Store()
const listGrid = ref<{instance:{value:Grid}}|null>(null)
const useListGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "360px",
  columns: [
    {
      id:'name',
      field: 'name',
      text: t('recipient.tabs.list.grid.name'),
      flex: 1,
    },
    {
      id:'recipientCount',
      field: 'recipientCount',
      text: t('recipient.tabs.list.grid.recipientCount'),
      flex: 1,
    },
  ],
  store: listGridStore,
  listeners:{
    selectionChange(event:any) {
      popupData.value!.recipientlists = event.selection.map((sr:any) => sr.originalData as RecipientList);
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const listGridConfig = reactive(useListGridConfig)

const typeOptions = ref<Array<Option>>((Object.values(TicketType) as Array<any>)
      .filter(tt => typeof tt === "number")
      .map((v:number) =>
          new Option(v, t(`dashboard.tabs.ticket.popups.edit.types.${TicketType[v]}`)))
)
const typeChanged = (id:number|null) => {
  popupData.value.type = id ?? 0 as TicketType;

  // clear fileInput
  if(isUpload.value) popupData.value.file = null;
}

const fileOptions = ref<Array<Option>>([]);
const fileChanged = (id:number|null)=>{
  popupData.value!.file = new TicketFileInfo();
  popupData.value!.file.fileID = id ?? -1;

  const selectedFile = fileList.value.filter(f => f.id === id)[0];
  popupData.value!.file.fileSize = selectedFile?.sizeInBytes ?? 0;
  popupData.value!.file.fileType = selectedFile?.type ?? "";
  popupData.value!.file.fileName = selectedFile?.name ?? "";
}

const setFileDropdown = async() => {
  const resp = await fileService.getForUser(ErrorLocationType.popup)
  if(!resp) return;

  fileList.value = resp;

  fileOptions.value = resp
      .filter(f => f.status === FileStatus.completed)
      .map(f => new Option(f.id, f.name));
}

const setConfigRestrictions = async() => {
  const config = await configService.get(ErrorLocationType.popup);

  const maxDate = new Date();
  const maximumDateOffset = config ? config.daysToDeleteUnusedTicketsMax! : 90;
  maxDate.setDate(maxDate.getDate() + maximumDateOffset);

  configuredMaximumAttemptsExpiresAtDate.value = getGermanIsoString(maxDate);
  configuredMaximumAttempts.value = config ? config.defaultOfAttempts! : 5;
}

const setRecipientData = async ()=>{
  const resp = await recipientService.getForUser(ErrorLocationType.popup);
  if(!resp) return;

  gridStore.data = resp;
}

const setRecipientListData = async ()=>{
  const resp = await recipientlistService.getForUser(ErrorLocationType.popup);
  if(!resp) return;

  listGridStore.data = resp;
}

const copyToClipboard = async () => {
  const url = `${baseURL}/external/${popupData.value?.urlToken}`;

  try {
    await navigator.clipboard.writeText(url);
    notify({
      title: "",
      text: $t('general.copied'),
      duration: 2000,
      type: "success"
    });
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};


onMounted(async ()=> {
  globalStore.modal.validator = {$validate:v$.value.$validate};

  // reset popupData
  popupData.value!.recipients = [];
  popupData.value!.recipientlists = [];

  isLoading.value = true;
  await setFileDropdown();
  await setConfigRestrictions();
  await setRecipientData();
  await setRecipientListData();
  isLoading.value = false;

  // set modifiedBy if context is edit
  if(isEdit.value && popupData.value) popupData.value.modifiedBy = globalStore.user?.displayName;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)('dashboard.tabs.ticket.popups.edit.type')) + " * ", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.type.$errors.length })
          }, [
            _createVNode(Select, {
              selected: popupData.value.type,
              searchable: true,
              options: typeOptions.value,
              labelProp: "name",
              disabled: isEdit.value,
              onSelectChanged: typeChanged
            }, null, 8, ["selected", "options", "disabled"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.type.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref($t)('dashboard.tabs.ticket.popups.edit.file')) + " ", 1),
          _withDirectives(_createElementVNode("span", null, "*", 512), [
            [_vShow, !isUpload.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.file.fileID.$errors.length })
          }, [
            _createVNode(Select, {
              disabled: (isUpload.value || isEdit.value) && popupData.value.type !== _unref(TicketType).staticDownload,
              selected: popupData.value.file?.fileID,
              searchable: true,
              options: fileOptions.value,
              labelProp: "name",
              onSelectChanged: fileChanged
            }, null, 8, ["disabled", "selected", "options"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.file.fileID.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ], 512), [
        [_vShow, !isLoading.value]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, isLoading.value]
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('dashboard.tabs.ticket.popups.edit.validToDate')), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass({error: v$.value.validity.expiresAt.$errors.length})
          }, [
            _createElementVNode("input", {
              type: "date",
              value: expiresAtDate.value,
              onChange: reactToDateValueChanges,
              max: configuredMaximumAttemptsExpiresAtDate.value,
              class: "w-full"
            }, null, 40, _hoisted_11),
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.validity.expiresAt.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('dashboard.tabs.ticket.popups.edit.attemptsRemaining')), 1),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            step: "1",
            max: configuredMaximumAttempts.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.security.attemptsRemaining) = $event)),
            class: "w-full"
          }, null, 8, _hoisted_16), [
            [_vModelText, popupData.value.security.attemptsRemaining]
          ])
        ])
      ]),
      (popupData.value.type === _unref(TicketType).staticDownload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref($t)('dashboard.tabs.file.popups.edit.staticLink')), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("input", {
                type: "text",
                value: _unref(NullOrUndefinedHelper)(popupData.value.urlToken) ? '' : `${_unref(baseURL)}/external/${popupData.value.urlToken}`,
                class: "flex-1 mr-0",
                disabled: true
              }, null, 8, _hoisted_20),
              _createElementVNode("button", {
                onClick: copyToClipboard,
                class: "btn primary m-0 p-0 h-[44px] min-w-[44px] flex justify-center items-center",
                disabled: _unref(NullOrUndefinedHelper)(popupData.value.urlToken)
              }, _hoisted_23, 8, _hoisted_21)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, _toDisplayString(_unref($t)('dashboard.tabs.file.popups.edit.messageToRecipient')), 1),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.message) = $event)),
            class: "w-full min-h-[80px]"
          }, null, 512), [
            [_vModelText, popupData.value.message]
          ]),
          _hoisted_27
        ])
      ]),
      (isEdit.value && popupData.value.type !== _unref(TicketType).staticDownload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_unref($t)('dashboard.tabs.ticket.popups.edit.sendTo')), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("input", {
                type: "text",
                value: `${popupData.value.recipient.fullName} ${popupData.value.recipient.email ? `(${popupData.value.recipient.email})` : ''}`,
                class: "w-full",
                disabled: ""
              }, null, 8, _hoisted_31),
              _hoisted_32
            ])
          ]))
        : _createCommentVNode("", true),
      (!isEdit.value || (isEdit.value && popupData.value.type === _unref(TicketType).staticDownload))
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(TabsWrapper, { activeTab: activeTab.value }, {
                default: _withCtx(() => [
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.recipients')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('dashboard.tabs.file.popups.edit.helpText.recipients')), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(GridInputFilter, {
                            gridStore: _unref(gridStore),
                            hideFilterButton: true
                          }, null, 8, ["gridStore"])
                        ]),
                        _createVNode(_unref(BryntumGrid), _mergeProps({
                          ref_key: "grid",
                          ref: grid
                        }, gridConfig, { readOnly: true }), null, 16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.recipientlists')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('dashboard.tabs.file.popups.edit.helpText.lists')), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(GridInputFilter, {
                            gridStore: _unref(listGridStore),
                            hideFilterButton: true
                          }, null, 8, ["gridStore"])
                        ]),
                        _createVNode(_unref(BryntumGrid), _mergeProps({
                          ref_key: "listGrid",
                          ref: listGrid
                        }, listGridConfig, { readOnly: true }), null, 16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.newRecipientTabTitle')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", {
                            innerHTML: _unref($t)('dashboard.tabs.file.popups.edit.helpText.newRecipient')
                          }, null, 8, _hoisted_42)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref($t)('recipient.tabs.recipient.popups.edit.name')) + " * ", 1),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.firstName.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((popupData.value.newRecipient.firstName) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.firstName]
                                ]),
                                _hoisted_46,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.firstName.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_unref($t)('recipient.tabs.recipient.popups.edit.lastName')) + " * ", 1),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.lastName.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popupData.value.newRecipient.lastName) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.lastName]
                                ]),
                                _hoisted_50,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.lastName.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_51, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_52, _toDisplayString(_unref($t)('recipient.tabs.recipient.popups.edit.email')) + " * ", 1),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.email.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((popupData.value.newRecipient.email) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.email]
                                ]),
                                _hoisted_54,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.email.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_55, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["activeTab"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})